import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { buildRouter } from '@/router'
import '@styles/styles.scss'
import '@paylibs/po-ui-kit/styles.css'
import App from './App.vue'
import { useGlobalStore } from '@stores/globalStore'

const pinia = createPinia()
const app = createApp(App)
app.use(pinia)

const globalStore = useGlobalStore()

globalStore.setAppWidth(window.innerWidth)
const router = buildRouter()
app.use(router)

app.mount('#app')
